import { DEFAULT_FONTS } from '../../constants/fonts';
export const buildFontFamilies = (typography) => {
    const defaultFontFamily = `"${typography.defaultFamily.name}", ${DEFAULT_FONTS}`;
    return {
        primary: defaultFontFamily,
        primary_bold: defaultFontFamily,
        light: defaultFontFamily,
        heavy: defaultFontFamily,
        light_bold: defaultFontFamily,
    };
};
//# sourceMappingURL=buildFontFamilies.js.map